<template>
  <div class="editor-wrapper">
    <item-div
      :title="$t('contracts.detail.virtualMachine')"
      :singledata="getVmType(contractInfo.vm_type)"
      class="info-item"
      v-if="contractInfo.vm_type"
    ></item-div>
    <template v-if="contractInfo.compiler_type">
      <item-div
        :title="$t('contracts.detail.compilerType')"
        :singledata="getCompilerType(contractInfo.compiler_type)"
        class="info-item"
      ></item-div>
      <item-div
        :title="$t('contracts.detail.compilerVersion')"
        :singledata="getCompilerVersion(contractInfo.compiler_version)"
        class="info-item"
      ></item-div>
      <item-div
        :title="$t('contracts.detail.optimizationEnabled')"
        :singledata="genOptimizationInfo(contractInfo)"
        class="info-item"
      ></item-div>
      <item-div
        :title="$t('contracts.detail.otherSettings')"
        :singledata="
          $t('contracts.detail.otherSettingsContent', {
            version: contractInfo.vm_version,
            license: contractInfo.license_type
          })
        "
        class="info-item"
      ></item-div>
    </template>
    <template v-if="source_list.length > 0">
      <item-div
        :title="$t('contracts.detail.contractSourceCode')"
        class="info-item"
        :singledata="''"
      ></item-div>
      <div
        class="code-item"
        v-for="(source, index) in source_list"
        :key="index"
      >
        <source-code
          :code="source.source_code"
          :title="genSourceTitle(source_list, index)"
        />
      </div>
    </template>
    <div class="code-item" v-if="contractInfo.settings">
      <source-code
        :code="contractInfo.settings"
        lang="json"
        :show-line-number="false"
        :title="$t('contracts.detail.settings')"
      />
    </div>
    <div class="code-item" v-if="constructor_arguments">
      <source-code
        :code="constructor_arguments"
        lang="plain"
        :show-line-number="false"
        :title="$t('contracts.detail.constructorArgument')"
      />
    </div>
  </div>
</template>

<script>
import { ethers } from "ethers";
import SourceCode from "./SourceCode.vue";
import itemDiv from "../common/DetailItemH";
import compiler_version from "./compiler_version_list";

const compilerType = {
  "Solidity(SingleFile)": "Solidity (Single file)",
  "Solidity(Multi-PartFiles)": "Solidity (Multi-Part files)"
};

const vmType = {
  evm: "EVM",
  neovm: "NeoVM",
  wasmvm: "WasmVM"
};

export default {
  name: "SourceCodeList",
  components: {
    itemDiv,
    SourceCode
  },
  props: {
    contractInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    constructor_arguments() {
      const construct_argument = this.contractInfo.construct_argument;
      if (!construct_argument) return "";
      return `
${construct_argument}

-----Decoded View---------------
${this.genDecodedView(construct_argument)}

-----Encoded View---------------
${this.genEncodedView(construct_argument)}
      `;
    },
    source_list() {
      const source_code = this.contractInfo.source_code;
      if (!source_code) return [];
      try {
        return JSON.parse(source_code);
      } catch (error) {
        return [];
      }
    }
  },
  methods: {
    genDecodedView(str) {
      const iface = new ethers.utils.Interface(this.contractInfo.abi);
      const types = iface.deploy.inputs.map(p => p.type);
      const names = iface.deploy.inputs.map(p => p.name);
      const values = ethers.utils.defaultAbiCoder.decode(types, `0x${str}`);

      let res = "";
      for (let i = 0; i < values.length; i++) {
        if (i !== 0) res += "\n";
        res += `Arg [${i}]: ${names[i]} (${types[i]}): ${values[i]}`;
      }
      return res;
    },
    genEncodedView(str) {
      let res = `${Math.ceil(str.length / 64)} Constructor Arguments found:`;

      let i = 0;
      while (i < Math.floor(str.length / 64)) {
        res += `\nArg [${i}]: ${str.slice(i * 64, (i + 1) * 64)}`;
        i++;
      }
      return res;
    },
    genSourceTitle(source_list, i) {
      const source = source_list[i];
      if (source_list.length === 1) return "";
      return `${this.$t("contracts.detail.contractSourceCodeFile", {
        index: i + 1,
        length: source_list.length
      })}${source["name"]}`;
    },
    genOptimizationInfo(info) {
      return info.optimization
        ? this.$t("contracts.detail.OptimizationOn", {
            runs: info.optimization_run
          })
        : this.$t("contracts.detail.OptimizationOff", {
            runs: info.optimization_run
          });
    },
    getCompilerType(key) {
      return compilerType[key];
    },
    getVmType(key) {
      return vmType[key.toLowerCase()];
    },
    getCompilerVersion(key) {
      const item = compiler_version.find(item => item.includes(key));
      if (item) return item;
    }
  }
};
</script>

<style lang="less" scoped>
.code-item {
  margin-top: 35px;

  &:first-child {
    margin-top: 40px;
  }
}
.info-item {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/contract/SourceCodeList.vue